import Vue from 'vue'
import Vuex from 'vuex'

import locationMethod from "./modules/locationMethod.js"
import index from "./modules/index.js"
import solution from "./modules/solution.js"
import news from "./modules/news.js"
import successfulCases from "./modules/successfulCases.js"
import qualificationAndHonors from "./modules/qualificationAndHonors.js"
import contactUs from "./modules/contactUs.js"
import applications from "./modules/applications.js"
import recruit from "./modules/recruit.js"

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		locationMethod,
		index,
		solution,
		news,
		successfulCases,
		qualificationAndHonors,
		contactUs,
		applications,
		recruit
	},
	strict: true
})



// WEBPACK FOOTER //
// ./src/store/index.js